import {
  BellNotifications,
  Calendar,
  ClockWatch,
  ColorPalette,
  Keyboard,
  Rocket,
  User,
  World,
} from '@griply/assets';
import React from 'react';

export enum SettingsSection {
  Account = 'account',
  Subscription = 'subscription',
  QuickEntry = 'quick-entry',
  Notifications = 'notifications',
  Theme = 'theme',
  DateTime = 'date-time',
  Language = 'language',
  Calendar = 'calendar',
}

export type SettingsNavItem = {
  section: SettingsSection;
  translationLabel: string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
};

export type SettingsNavGroup = {
  translationLabel?: string;
  items: SettingsNavItem[];
};

export const settingsNavGroups: SettingsNavGroup[] = [
  {
    items: [
      {
        section: SettingsSection.Account,
        translationLabel: 'forms.user-settings.sections.account.label',
        icon: User,
      },
      {
        section: SettingsSection.Subscription,
        translationLabel: 'forms.user-settings.sections.subscription.label',
        icon: Rocket,
      },
    ],
  },
  {
    translationLabel: 'forms.user-settings.sections.general.label',
    items: [
      {
        section: SettingsSection.QuickEntry,
        translationLabel: 'forms.user-settings.sections.quick-entry.label',
        icon: Keyboard,
      },
      {
        section: SettingsSection.Notifications,
        translationLabel: 'forms.user-settings.sections.notifications.label',
        icon: BellNotifications,
      },
      {
        section: SettingsSection.Theme,
        translationLabel:
          'forms.user-settings.sections.appearance.theme-preference.label',
        icon: ColorPalette,
      },
      {
        section: SettingsSection.DateTime,
        translationLabel:
          'forms.user-settings.sections.date-and-time.nav-label',
        icon: ClockWatch,
      },
      {
        section: SettingsSection.Language,
        translationLabel: 'forms.user-settings.sections.language.label',
        icon: World,
      },
    ],
  },
  {
    translationLabel: 'forms.user-settings.sections.integrations.label',
    items: [
      {
        section: SettingsSection.Calendar,
        translationLabel: 'forms.user-settings.sections.calendar.label',
        icon: Calendar,
      },
    ],
  },
];

export const settingsNavItems = settingsNavGroups.flatMap(
  (group) => group.items,
);
